import api from './client';
import { API_ENDPOINTS } from './endpoints';

export interface ErrorParameterApiItem {
  _id: string;
  error_classification: string;
  error_category: string;
  error_code_description: string;
  standard_error_code: string;
  error_weightage: number;
  remarks?: string;
  meta?: { status?: string };
  createdAt?: string;
  updatedAt?: string;
}

export interface ErrorParametersListResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: {
    errorParameters?: ErrorParameterApiItem[];
    count?: number;
  } | ErrorParameterApiItem[];
}

export interface UpsertErrorParameterPayload {
  id?: string;
  error_classification: string;
  error_category: string;
  error_code_description: string;
  standard_error_code: string;
  error_weightage: number;
  remarks?: string;
}

export interface ErrorParameterMutationResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: ErrorParameterApiItem | null;
}

export const getErrorParameters = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
}): Promise<ErrorParametersListResponse> => {
  return api.get<ErrorParametersListResponse>(API_ENDPOINTS.errorParameters.list, { params });
};

export const upsertErrorParameter = async (
  payload: UpsertErrorParameterPayload,
): Promise<ErrorParameterMutationResponse> => {
  return api.post<ErrorParameterMutationResponse, UpsertErrorParameterPayload>(
    API_ENDPOINTS.errorParameters.upsert,
    payload,
  );
};

export const deleteErrorParameter = async (id: string): Promise<ErrorParameterMutationResponse> => {
  return api.delete<ErrorParameterMutationResponse>(
    `${API_ENDPOINTS.errorParameters.list}/${id}`,
  );
};
